module.exports = __webpack_public_path__ + "img/case-logo-31.6ddbdf0f.png";